/** @jsx jsx */
import type { CSSProperties } from 'react';
import { css, jsx } from '@compiled/react';
import {
	CustomItem,
	type CustomItemComponentProps,
	type CustomItemProps,
} from '@atlaskit/side-navigation';
import { token } from '@atlaskit/tokens';
import { useSidebarTheme } from '../../../controllers/sidebar-theme/index.tsx';

const bgColorCssVar = '--header-bg-color';
const textColorCssVar = '--header-text-color';

const containerStyles = css({
	color: `var(${textColorCssVar})`,
	position: 'relative',
	userSelect: 'auto',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'[data-item-title]': {
		font: token('font.heading.xsmall'),
		color: `var(${textColorCssVar}, ${token('color.text')})`,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'div&:hover': {
		cursor: 'default',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'div&:active': {
		color: token('color.text'),
	},
});

const bgColorThemeStyles = css({
	backgroundColor: `var(${bgColorCssVar})`,
});

const colorThemeStyles = css({
	color: `var(${textColorCssVar})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'[data-item-description]': {
		color: `var(${textColorCssVar})`,
	},
});

export const HeaderContainer = ({ className, ...props }: CustomItemComponentProps) => {
	const theme = useSidebarTheme();
	const item = theme?.navigation?.item;
	return (
		<div
			css={[
				containerStyles,
				item?.background?.default && bgColorThemeStyles,
				item?.color?.default && colorThemeStyles,
			]}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
			className={className}
			// eslint-disable-next-line jira/react/no-style-attribute
			style={
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				{
					[bgColorCssVar]: item?.background?.default,
					[textColorCssVar]: item?.color?.default,
				} as CSSProperties
			}
			{...props}
		/>
	);
};

type CustomHeaderProps = CustomItemProps & {
	className?: string;
};

export const CustomHeader = ({ iconBefore, iconAfter, children, ...rest }: CustomHeaderProps) => {
	return (
		<CustomItem
			{...rest}
			component={HeaderContainer}
			iconBefore={iconBefore}
			iconAfter={iconAfter}
			isTitleHeading
		>
			{children}
		</CustomItem>
	);
};
